import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { TopupBalanceForm } from '@/features/consumer/topup-balance-form';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTrack } from '@/features/tracking/useTrack';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/topup-balance'
)({
  component: TopupBalancePage,
});

function TopupBalancePage() {
  const navigate = useNavigate();
  const track = useTrack();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => {
            track('click', {
              eventAction: 'clickButton',
              eventCategory: 'myWallet',
              eventDescription: 'clickBack',
              eventLabel: 'myWallet',
              screenName: 'myWalletPage',
            });
            navigate({ to: '/my-wallet' });
          }}
        />
        <HeaderDashboard.Title>Add Hour</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <TopupBalanceForm />
      </div>
    </div>
  );
}
